'use strict';

angular.module('ntmApp').factory('ProfileTab', function () {

    function ProfileTab() {

        var self = this;

        self.getTab = function () {
            return;
        };

    }

    return (ProfileTab);
});